import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import BudgetImportServices from "./BudgetImportServices";
import { toast } from "react-toastify";
import { successAlert } from "../../Global/GlobalSlice";

export const importBudget = createAsyncThunk(
  "budget/importBudget",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await BudgetImportServices.importBudget(data);

      if (responseData?.successful === true) {
        dispatch(
          successAlert({
            message: responseData?.data?.statusMessage,
          })
        );
        toast(responseData?.data?.statusMessage);
      }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createLineItem = createAsyncThunk(
  "budget/createLineItem",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      toast.loading("Processing...");
      const responseData = await BudgetImportServices.createLineItem(data);

      if (responseData?.successful === true) {
        toast.dismiss();
        toast.success(responseData?.statusMessage);
      }

      if (responseData?.successful === false) {
        toast.dismiss();
        toast.error(responseData?.statusMessage);
      }

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.dismiss();
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getBudgetItems = createAsyncThunk(
  "budget/getBudgetItems",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await BudgetImportServices.getBudgetItems(data);

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.data?.statusMessage,
      //     })
      //   );
      //   toast(responseData?.data?.statusMessage);
      // }
      // console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getBudgetSummary = createAsyncThunk(
  "budget/getBudgetSummary",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      const responseData = await BudgetImportServices.getBudgetSummary();

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.data?.statusMessage,
      //     })
      //   );
      //   toast(responseData?.data?.statusMessage);
      // }
      // // console.log({ responseData });

      return responseData?.responseObject;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  isLoading: false,
  error: null,
  data: {},
  summary: {},
};

const reducers = {
  viewBudget(state, action) {
    return { ...state, data: action.payload };
  },
};

export const BudgetImportSlice = createSlice({
  name: "budget",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(importBudget.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(importBudget.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(importBudget.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(createLineItem.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(createLineItem.fulfilled, (state) => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addCase(createLineItem.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getBudgetItems.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getBudgetItems.fulfilled, (state, action) => {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
        };
      })
      .addCase(getBudgetItems.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
    builder
      .addCase(getBudgetSummary.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getBudgetSummary.fulfilled, (state, action) => {
        return {
          ...state,
          summary: action.payload,
          isLoading: false,
        };
      })
      .addCase(getBudgetSummary.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export const { viewBudget } = BudgetImportSlice.actions;

export default BudgetImportSlice.reducer;
